import { render, staticRenderFns } from "./scope84.vue?vue&type=template&id=ef1ff5b8&scoped=true"
import script from "./scope84.vue?vue&type=script&lang=js"
export * from "./scope84.vue?vue&type=script&lang=js"
import style0 from "./scope84.vue?vue&type=style&index=0&id=ef1ff5b8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef1ff5b8",
  null
  
)

export default component.exports